import React from "react";
import Cards from '../Cards/Cards';
import "./Home.css"

function Home() {

  return (
    <main className="main">
      <h1>Videogames</h1>
      <Cards/>
    </main>
  );
}

export default Home;